module.exports = __webpack_public_path__ + "static/project-11a-7c34c9a2abe314f2a64d1d3d383f5e0a.png";